module.exports = __webpack_public_path__ + "img/hata no kokoro_lw.c8b4e1d9.png";